import React from 'react';
import { ContentWrapper, Header, PopupContent, PopupImage, PopupTextBlock } from './Popups.styles';

export const ResolveConfirmPopup = () => {
  return (
    <ContentWrapper>
      <PopupContent>
        <PopupImage src="/images/green-alert-bell.svg" alt="green-alert-bell" />
        <PopupTextBlock>
          <Header>Are you sure you want to resolve?</Header>
        </PopupTextBlock>
        <PopupTextBlock>
          Resolving the ticket closes the conversation and sends the customer a satisfaction survey.
        </PopupTextBlock>
      </PopupContent>
    </ContentWrapper>
  );
};
export default ResolveConfirmPopup;
